export default __webpack_public_path__ + "static/1390-580aae51c137951a448b154d891758e6.gif";